import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/auth/AuthContext";
import { usePortalNavigationAccess } from "@/hooks/usePortalNavigationAccess";
import { LOGIN_PAGE } from "@/router/paths";
export default function RootRedirect() {
    const { isAuthenticated } = useAuth();
    const { defaultPage, isLoading } = usePortalNavigationAccess(isAuthenticated);
    if (isAuthenticated && isLoading) {
        return null;
    }
    // The auth check is already handled in DashboardLayout
    // This component just handles the redirect logic
    return /*#__PURE__*/ _jsx(Navigate, {
        to: isAuthenticated ? defaultPage : LOGIN_PAGE,
        replace: true
    });
}
